import type { DocumentDownloadButtonProps } from "./document-download-button.type";
import type { ButtonProps } from "antd";

import { DownloadOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { downloadFile } from "@/modules/file-downloader";
import { truncate } from "@/utilities/string";

export const DocumentDownloadButton = ({
  document,
  loading = false,
  disabled = false,
  compact,
}: DocumentDownloadButtonProps) => {
  const { t } = useTranslation();

  const tooltip = document.name;
  const text = compact ? t("global:download") : truncate(document.name, 50);

  const buttonProps: ButtonProps = {
    loading,
    disabled,
    onClick: () => downloadFile({ url: document.url, name: document.name }),
    icon: <DownloadOutlined />,
    children: text,
  };

  if (text === tooltip) {
    return <Button {...buttonProps} />;
  }

  return (
    <Tooltip title={tooltip}>
      <Button {...buttonProps} />
    </Tooltip>
  );
};
